module.exports = __webpack_public_path__ + "assets/zjmp_icon2.6a16d146.svg";